/* GoBuildIt — gbi-pages.js (2026-10-18). Loaded by snippets/gbi-pages-assets.liquid on the pages that are not built
   from gbi sections. One job: on the policy pages, the "On this page" pills are a sideways row on phones; when the
   section's own script marks another pill as current (class "active"), slide that pill into view inside the row.
   It only moves the row sideways, never the page. */
(function () {
  'use strict';
  var navs = document.querySelectorAll('.gbs__sidebar-nav, .gbr__sidebar-nav, .gbpr__sidebar-nav');
  if (!navs.length || !('MutationObserver' in window)) return;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  Array.prototype.forEach.call(navs, function (nav) {
    var raf = 0;
    function reveal() {
      raf = 0;
      if (nav.scrollWidth <= nav.clientWidth + 1) return;
      var a = nav.querySelector('a.active');
      if (!a) return;
      var n = nav.getBoundingClientRect();
      var r = a.getBoundingClientRect();
      var pad = 16;
      var left = nav.scrollLeft;
      if (r.left - pad < n.left) left += r.left - pad - n.left;
      else if (r.right + pad > n.right) left += r.right + pad - n.right;
      else return;
      nav.scrollTo({ left: Math.max(0, left), behavior: reduce && reduce.matches ? 'auto' : 'smooth' });
    }
    new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(reveal); })
      .observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();
